import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/*
 * Mismo regex que `Validators.email` de Angular, pero exigiendo un punto en el
 * dominio: "mail@test" es inválido y "mail@test.com" válido. Portado tal cual de
 * `validators/email.validator.ts` del backoffice, para que los dos frontends
 * acepten exactamente lo mismo que el `@IsEmail()` del backend.
 */
const EMAIL =
  /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

/**
 * Valida el formato de un email. El campo vacío lo da por válido: de que sea
 * obligatorio se encarga `Validators.required`, así un campo sin tocar no
 * arranca en rojo.
 */
export const validadorEmail: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const valor = control.value;
  if (valor == null || valor.length === 0) return null;
  return EMAIL.test(valor) ? null : { email: true };
};
